// extracted by mini-css-extract-plugin
export default {"root":"Team_root__r+h0i","formContainer":"Team_formContainer__95xMz","deleteUser":"Team_deleteUser__pBP0K"};